import React, {Fragment, useRef, memo} from 'react';
import cx from "classnames";
import useStore from '../../modules/utils/store';
import { _AC, _API, _U } from '../../modules/utils';
import { useContext } from 'react';
import { AppContext } from '../../components/AppProvider';
import { useHistory } from 'react-router-dom';

const RegisterConsoleType = (props) => {
  const { iam,auth } = useContext(AppContext);
  const { item, onOff ,eventInfo ,preregInfo,setAccompanySessionIdx,setAccompanyAttendModal,waitTimer} = props;
  const { siteInfo } = useStore();
  const history = useHistory();

  const isBilingual = eventInfo?.eventIdx == 1098 || eventInfo?.eventIdx == 1199;
  const label = siteInfo?.eventLabel || '세션';

  // ✅ API 호출 대신 props로 받은 preregInfo 사용
  const preregExistent = preregInfo;

  const goSymposium = function (item, url) {
   let joinSessionChk = false;

   // ✅ preregExistent.sessionList로 직접 접근 (data 레벨 제거)
   if (preregExistent?.sessionList && Array.isArray(preregExistent.sessionList)) {
     for (let i in preregExistent.sessionList) {
       const sessionItem = preregExistent.sessionList[i];

       if (item?.idx == sessionItem?.idx) {
         joinSessionChk = true;
         break;
       }
     }
   }

   if (!joinSessionChk) {
     alert(isBilingual ? `You have not registered for this session.\n(참가 신청 하지 않은 세션입니다.)` : `참가 신청 하지 않은 세션입니다.`);
     return false;
   }

   if (onOff(item) == "ENTER_OK" || onOff(item) == "ONAIR") {
     if(item?.accompanyYn == 'Y'){
       setAccompanySessionIdx(item?.idx);
       setAccompanyAttendModal(true);
       $(body).css("overflow", "hidden");
     }else{
       // ✅ React Router로 네비게이션 (Context 유지, 타이밍 문제 없음)
       history.push(url);
     }
    } else if(onOff(item) == "END"){
      return false;
    } else if(onOff(item) == "BEFORE" && item?.cAccessTime == 0){
      alert(isBilingual ? `Entry will be available at the scheduled start time.\n(정시부터 입장이 가능합니다.)` : `정시부터 입장이 가능합니다.`);
      return false;
    }  else {
      alert(isBilingual ? `Entry to the symposium will be available ${item?.cAccessTime} minutes before the start time.\n(${item?.cAccessTime}분 전부터 심포지엄 입장이 가능합니다.)` : `${item?.cAccessTime}분 전부터 심포지엄 입장이 가능합니다.`);
      return false;
    }
  };

  // ✅ useEffect 제거: 이제 props로 preregInfo를 받음
  return(
    <Fragment>
       {item.eventEnterYn == "Y" && (
        <>
          <div className="pre">
            <Fragment>
              <button onClick={(e) => { $(".modal-stack").remove(); goSymposium(item, `/event/${eventInfo?.eventIdx}/session/${item.idx}/default`); }}
                      className={cx({ basic_btn: true, basic_btn_off: onOff(item) == "BEFORE" || onOff(item) == "END"})} >
                {item?.accessButtonLabel || `심포지엄 접속`}
                {item?.accompanyYn == 'Y' ? (<span>(동반참석 진행)</span>) : '' }
              </button>
            </Fragment>
          </div>
          {item?.consoleType && (
            <Fragment>
              {onOff(item) == "BEFORE" ? (
                <p className="ent_span">
                  {isBilingual ? (
                    <>
                      <small>Entry to the {label} will be available in <b className="time_b">{waitTimer(item)}</b>.</small>
                      <span>(<b className="time_b">{waitTimer(item)}</b> 후부터 {label} 입장이 가능합니다.)</span>
                    </>
                  ) : (
                    <>
                      <small><b className="time_b">{waitTimer(item)}</b> 후부터 {label}</small>
                      <span>입장이 가능합니다.</span>
                    </>
                  )}
                </p>
              ) : onOff(item) == "ENTER_OK" ? (
                <p className="ent_span">
                  {isBilingual ? <>Entry to the current {label} is now available.<br />(현재 {label} 입장이 가능합니다.)</> : `현재 ${label} 입장이 가능합니다.`}
                </p>
              ) : onOff(item) == "ONAIR" ? (
                <p className="ent_span">
                  {isBilingual ? <>The {label} is currently in progress.<br />(현재 {label} 진행 중입니다.)</> : `현재 ${label} 진행 중입니다.`}
                </p>
              ) : (
                <p className="ent_span">
                  <small>{isBilingual ? <>The {label} has ended.<br />(해당 {label}(이)가 종료되었습니다.)</> : `해당 ${label}(이)가 종료되었습니다.`}</small>
                </p>
              )}
            </Fragment>
          )}
        </>
       )}
    </Fragment>
  )
}

// ✅ React.memo로 불필요한 재렌더링 방지
export default memo(RegisterConsoleType);